import api from "../api";

const END_POINT = "/api/sync";

export async function getAllSyncHttp() {
  return await api.get(`${END_POINT}`);
}

export async function getLastSyncHttp() {
  return await api.get(`${END_POINT}/last`);
}

export async function getSyncByIdHttp(id) {
  return await api.get(`${END_POINT}/${id}`);
}

export async function execSyncImportHttp() {
  return await api.get(`${END_POINT}/import`);
}

export async function truncateTablesImportHttp() {
  return await api.get(`${END_POINT}/truncate`);
}
